"use client";

import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import { ArrowRight, Instagram } from "lucide-react";
import { defaultSiteSettings, type SiteSettings } from "@/lib/site-settings";
import type { GalleryItem } from "@/lib/content-types";
import { ImageZoom } from "@/components/image-zoom";

export function GallerySection() {
  const [liveGallery, setLiveGallery] = useState<GalleryItem[]>([]);
  const [siteSettings, setSiteSettings] = useState<SiteSettings>(defaultSiteSettings());
  useEffect(() => { void fetch("/api/gallery", { cache: "no-store" }).then((response) => response.ok ? response.json() : null).then((data) => { if (Array.isArray(data?.gallery) && data.gallery.length) setLiveGallery(data.gallery); }).catch(() => undefined); }, []);
  useEffect(() => { void fetch("/api/site-settings", { cache: "no-store" }).then((response) => response.ok ? response.json() : null).then((data) => { if (data?.settings) setSiteSettings(data.settings); }).catch(() => undefined); }, []);
  return (
    <section className="section gallery-section">
      <div className="container">
        <div className="section-heading gallery-heading">
          <div><p className="section-label">Réalisations</p><h2>Un aperçu du travail</h2></div>
          <div className="heading-actions"><Link href="/realisations" className="text-link">Toute la galerie <ArrowRight size={18} /></Link><a href={siteSettings.instagram} target="_blank" rel="noreferrer" className="text-link"><Instagram size={18} /> Instagram</a></div>
        </div>
        <div className="gallery-preview-grid">
          {liveGallery.slice(0, 3).map((item) => (
            <figure className="gallery-item" key={item.title}>
              <ImageZoom src={item.image} alt={item.title} className="gallery-image-zoom"><Image src={item.image} alt="" fill sizes="(max-width: 700px) 100vw, 33vw" /></ImageZoom>
              <figcaption><span>{item.category}</span><strong>{item.title}</strong></figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
